import React from "react";

import { formatShareQty } from "../utils/investorRedeemEligibility";
import { projectSupplyMetrics } from "../utils/projectShareMetrics";

function MetricCell({ label, value, highlight = false }) {
  return (
    <div className={`invx-portfolio-row__metric${highlight ? " invx-portfolio-row__metric--mine" : ""}`}>
      <span className="invx-portfolio-row__metric-label">{label}</span>
      <span className="invx-portfolio-row__metric-value">{value}</span>
    </div>
  );
}

/**
 * Portfolio row: project identity, live cap-table supply, and position cost/NAV/value.
 */
export default function PortfolioHoldingMetrics({
  project,
  sharesHeld,
  codeDisplay,
  projectName,
  sharesFormatted,
  costFormatted,
  navFormatted,
  valueFormatted,
  title,
  showPositionMetrics = true,
  /** Project code/name line (hide when parent toggle already shows it). */
  showProjectIdentity = true,
}) {
  const supply = project ? projectSupplyMetrics(project) : null;
  const myHoldings =
    sharesHeld != null ? `${formatShareQty(sharesHeld)} sh` : sharesFormatted ? `${sharesFormatted} sh` : "—";

  return (
    <div className="invx-portfolio-row__inner" title={title}>
      {showProjectIdentity ? (
        <div className="invx-portfolio-row__project-line">
          <span className="invx-portfolio-row__code">{codeDisplay || "—"}</span>
          <span className="invx-portfolio-row__dash" aria-hidden="true">
            –
          </span>
          <span className="invx-portfolio-row__name">{projectName || "—"}</span>
        </div>
      ) : null}

      {supply ? (
        <div
          className="invx-portfolio-row__metrics invx-portfolio-row__metrics--supply"
          role="group"
          aria-label="Share supply"
          aria-live="polite"
          aria-atomic="true"
        >
          <MetricCell label="Total Shares" value={`${formatShareQty(supply.totalShares)} sh`} />
          <MetricCell label="Issued (Sold)" value={`${formatShareQty(supply.issuedShares)} sh`} />
          <MetricCell label="My Holdings" value={myHoldings} highlight />
          <MetricCell label="Available" value={`${formatShareQty(supply.availableShares)} sh`} />
        </div>
      ) : null}

      {showPositionMetrics ? (
        <div className="invx-portfolio-row__metrics invx-portfolio-row__metrics--position" role="group" aria-label="Position figures">
          {!supply ? (
            <MetricCell label="Shares" value={sharesFormatted ? `${sharesFormatted} sh` : "—"} />
          ) : null}
          <MetricCell label="Cost" value={costFormatted} />
          <MetricCell label="NAV/sh" value={navFormatted} />
          <MetricCell label="Unrealised Value" value={valueFormatted} />
        </div>
      ) : null}
    </div>
  );
}
